import React, { Children } from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: ReactNode;
  className?: string;
  id?: string;
  delay?: number;
  staggerChildren?: boolean;
  slideFrom?: 'left' | 'right' | 'bottom';
}
export function Section({
  children,
  className = '',
  id,
  delay = 0,
  staggerChildren = false,
  slideFrom = 'bottom'
}: SectionProps) {
  const variants = {
    hidden: {
      opacity: 0,
      y: slideFrom === 'bottom' ? 30 : 0,
      x: slideFrom === 'left' ? -30 : slideFrom === 'right' ? 30 : 0
    },
    visible: {
      opacity: 1,
      y: 0,
      x: 0,
      transition: {
        duration: 0.6,
        delay,
        ease: 'easeOut',
        when: 'beforeChildren',
        staggerChildren: staggerChildren ? 0.1 : 0
      }
    }
  };
  return <motion.section id={id} initial="hidden" whileInView="visible" viewport={{
    once: true,
    margin: '-50px'
  }} variants={variants} className={`w-full max-w-3xl mx-auto px-6 py-5 md:py-8 ${className}`} data-id="element-440">
      {children}
    </motion.section>;
}